import React, { useEffect, useMemo, useRef, useState } from "react"
import {ClipLoader} from 'react-spinners'
import n0 from './wingoimg/0.png'
import n1 from './wingoimg/1.png'
import n2 from './wingoimg/2.png'
import n3 from './wingoimg/3.png'
import n4 from './wingoimg/4.png'
import n5 from './wingoimg/5.png'
import n6 from './wingoimg/6.png'
import n7 from './wingoimg/7.png' 
import n8 from './wingoimg/8.png'
import n9 from './wingoimg/9.png'

import b1 from './k3img/b1.png'
import b2 from './k3img/b2.png'
import b3 from './k3img/b3.png'
import b4 from './k3img/b4.png'
import b5 from './k3img/b5.png'
import b6 from './k3img/b6.png' 

import kn1 from './k3img/b1.svg'
import kn2 from './k3img/b2.svg'
import kn3 from './k3img/b3.svg'
import kn4 from './k3img/b4.svg'
import kn5 from './k3img/b5.svg'
import kn6 from './k3img/b6.svg' 


import LineTo from 'react-lineto'
import _ from 'lodash'


import { Button, Spin } from "antd"
import { useTranslation } from "react-i18next"
import { hit, useCurrentGame } from "../../hooks/useDraw"
import {blue} from "../../theme/colors"
import DrawHistoryModal from '../../components/DrawHistoryModal';
import { useWingoFlatPics, useWingoGrayPics, useWingoPics } from "./LotteryDrawAnim"
import { getChunk, getRoute } from "../../utils/routeutil"
 
export const WinGoDrawHistory:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  const [showNum,setShowNum] = useState(false)
  useEffect(()=>{
    setShowNum(false)
    setTimeout(() => {
        setShowNum(true)
    }, 0);
  },[historyDrawResult])
  return <>
         <div style={{ position:'relative',display:'flex',flexDirection:'row',borderTopLeftRadius:10,borderTopRightRadius:10, paddingTop:10,paddingBottom:10,background:blue[100]}}>
            <div style={{flex:2,color:'black',textAlign:'center'}}>
              {t('Period')}
            </div>
            <div style={{flex:1,color:'black',textAlign:'center'}}>
              {t('Number')}
            </div>
            <div style={{flex:1,color:'black',textAlign:'center'}}>
              {t('B/S')}
            </div>
            <div style={{flex:1,color:'black',textAlign:'center'}}>
              Color
            </div>
            {/* <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'blac'}}/> */}
          </div>
          {historyDrawResult.map((item:any,index)=>{
            if(!item){
              return <></>
            }
            const number = parseInt(item.content?.number)
            const plan = item.plan
            const hits = hit(item)
            return  <div style={{background:index%2?'white':'#f9f9f9',display:'flex',flexDirection:'row',flex:1,position:'relative',padding:0, }}>
            <div style={{flex:2,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>
              *{_.takeRight(item.issueNumber,6).join('')}
            </div>
            <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',height:50}}>
              {/* <span style={{color:number%2?'green':'orange',fontWeight:'bold',fontSize:30}}>{number}</span> */}
              {item.content ? 
                    (showNum?<span style={{
                      color:number%2?'#18B660':'#FB5B5B',
                      background:
                      number==0?
                      'linear-gradient(180deg,#FB5B5B 50.96%,rgb(182,89,254) 50.97%)'
                      : (number==5?'linear-gradient(180deg,#18B660 50.96%,rgb(182,89,254) 50.97%)':'transparent'),
                      backgroundClip: (number==0||number==5)?'text':'',
                      WebkitTextFillColor:(number==0||number==5)?'transparent':'',
                    fontWeight:'bold',fontSize:30}}>{number}</span>:null)
                : t('Pending')}
              
            </div>
            <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
              <span> 
                {!item.content? t('Pending') : (number>=5?t('Big'):t('Small')) }
                {hits && <span style={{color:'white',fontSize:10,background:'red',borderRadius:2,paddingLeft:2,paddingRight:2,marginLeft:2}} >{hits?'Hit':''}</span>}
              </span>
              {plan && <span style={{fontSize:10}}>Plan:{plan.content.bs=='b'?t('Big'):t('Small')}</span>}
            </div>
            <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',}}>
              {!item.content &&  t('Pending') }
              {item.content?<span style={{width:10,height:10,background:number%2?'#18B660':'#FB5B5B',borderRadius:20}}/>:<></>}
              {item.content && number%5===0 ?<span style={{width:10,height:10,background:'#B659FE',borderRadius:20,marginLeft:5}}/>:<></>}
            </div>
            <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'#efefef'}}/>
          </div>
          })}
  </>
}


export const WinGoRouteMap:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
  const chunkedDraws = useMemo(()=>{
    const [first,...rest] = historyDrawResult
    const res =  _.chunk(_.take(rest,72),6)
    console.log('res',res)
    return res
  },historyDrawResult)
  const wingoPics = useWingoFlatPics()
  const zhupans = useMemo(()=>{
    const [first,...rest] = historyDrawResult
    const res =  _.take(rest,72)
    const columns:string[][] = []
    
    const route = getRoute(res.map(i=>i.content.number>4?'B':'S'))
    // for(let i =0;i<res.length;i++){
    //   const bs = res[i].content.number > 4?'b':'s'
    //   console.log('res[i]',res[i].content.number,bs,i)
      
    // }
    // getRoute
    const res1 = _.takeRight(route,24)
     
    console.log('res1',res1)
    return res1
  },[historyDrawResult])
  return <>
  <div style={{display:'flex',flexDirection:'row-reverse',padding:10,paddingBottom:0}}>
    {chunkedDraws.map((columnDraws,rowIndex)=>{
      return <div style={{display:'flex',flexDirection:'column-reverse',flex:1}}>{columnDraws.map((draw,columnIndex)=>{
        return <div style={{display:'flex',alignItems:'center',justifyContent:'center',flex:1,position:'relative'
        // borderLeftWidth:1,borderBottomWidth:1,borderColor:'lightgray',borderRightWidth:row==0?1:0,borderTopWidth:i==columnDraws.length-1?1:0
        }}>
           <img src={wingoPics[draw?.content?.number]} style={{width:'80%',height:'80%'}}/>
           {rowIndex===chunkedDraws.length-1&&<div style={{width:1,position:'absolute',left:0,bottom:0,top:0,background:'lightgray'}}/>}
           <div style={{width:1,position:'absolute',right:0,bottom:0,top:0,background:'lightgray'}}/>

           {columnIndex === columnDraws.length-1 && <div style={{height:1,position:'absolute',left:0,top:0,right:0,background:'lightgray'}}/>}
           <div style={{height:1,position:'absolute',left:0,bottom:0,right:0,background:'lightgray'}}/>
          </div>
      })}</div> 
    })}
    
  </div> 
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingTop:0}}>
    {zhupans.map((column,columnIndex)=>{
      return <div style={{flexDirection:'column',display:'flex',flex:1,position:'relative'}}>
          {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
        </div>
    })}
  </div> 
  </>
}

export const WinGoDragons:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
   
  const bsResultArrayFinal = useMemo(()=>{
    if(!historyDrawResult){
      return
    }
    const [first,...restHistoryDrawResult] = historyDrawResult
    const bsResult = getChunk(restHistoryDrawResult.map(i=>i?.content?.number>4?'Big':'Small'))
    const bsResultObject:{[key:string]:string[]} = {}
    bsResult.forEach((item,index)=>{
        if(item.length>=2){
          // @ts-ignore
          bsResultObject[index+''] = item
        }
    })
    
    console.log('bsResult',bsResultObject,)
    const bsResultArrayFinal:{state:string,data:string[]}[] = []
    Object.keys(bsResultObject).forEach((index:string)=>{
      bsResultArrayFinal.push({
        state:index==='0'?'Active':'Expired',
        data:bsResultObject[index]
      })
    })
    console.log('bsResultArrayFinal',bsResultArrayFinal)
    return _.take(bsResultArrayFinal,2)
  },[historyDrawResult])
  const purpleResultArrayFinal = useMemo(()=>{
    if(!historyDrawResult){
      return
    }
    const [first,...restHistoryDrawResult] = historyDrawResult
    const bsResult =  getChunk(restHistoryDrawResult.map(i=>i?.content?.number==0||i?.content?.number==5?'Purple':'null'))
    const bsResultObject:{[key:string]:string[]} = {}
    bsResult.forEach((item,index)=>{
        if(item.length>=2){
          // @ts-ignore
          bsResultObject[index+''] = item
        }
    })
    
    console.log('bsResult',bsResultObject,)
    let bsResultArrayFinal:{state:string,data:string[]}[] = []
    Object.keys(bsResultObject).forEach((index:string)=>{
      bsResultArrayFinal.push({
        state:index==='0'?'Active':'Expired',
        data:bsResultObject[index]
      })
    })
    bsResultArrayFinal = bsResultArrayFinal.filter(i=>i.data[0]!='null')
    console.log('purpleResultArrayFinal',bsResultArrayFinal)
    return _.take(bsResultArrayFinal,2)
  },[historyDrawResult])

  const greenRedResultArrayFinal = useMemo(()=>{
    if(!historyDrawResult){
      return
    }
    const [first,...restHistoryDrawResult] = historyDrawResult
    const bsResult =  getChunk(restHistoryDrawResult.map(i=>i?.content?.number%2?'Green':'Red'))
    const bsResultObject:{[key:string]:string[]} = {}
    bsResult.forEach((item,index)=>{
        if(item.length>=2){
          // @ts-ignore
          bsResultObject[index+''] = item
        }
    })
    
    console.log('bsResult',bsResultObject,)
    let bsResultArrayFinal:{state:string,data:string[]}[] = []
    Object.keys(bsResultObject).forEach((index:string)=>{
      bsResultArrayFinal.push({
        state:index==='0'?'Active':'Expired',
        data:bsResultObject[index]
      })
    })
    // bsResultArrayFinal = bsResultArrayFinal.filter(i=>i.data[0]!='null')
    console.log('purpleResultArrayFinal',bsResultArrayFinal)
    return _.take(bsResultArrayFinal,2)
  },[historyDrawResult])
  const arrayFinal = useMemo(()=>{
      if(!bsResultArrayFinal){
        return []
      }
      if(!purpleResultArrayFinal){
        return []
      }
      if(!greenRedResultArrayFinal){
        return []
      }
      return [...bsResultArrayFinal,...purpleResultArrayFinal,...greenRedResultArrayFinal].sort((a,b)=>{
        const valueA = a.state=='Active'?1:0
        const valueB = b.state=='Active'?1:0
        return valueB - valueA
      })
  },[bsResultArrayFinal,purpleResultArrayFinal])
  return <>
  
  <div style={{flexDirection:'column',display:'flex' }}>
    <DragonHead/>
    {arrayFinal?.map((row:any,index:number)=>{
      let color
      switch(row.data[0]){
        case 'Red':
            color = 'red'
            break;
        case 'Green':
            color = 'green'
            break;
        case 'Purple':
            color = 'purple'
            break;

      }
      return <div style={{flexDirection:'row',display:'flex',flex:1,paddingTop:10,paddingBottom:10,background:index%2?'white':'#f9f9f9' }}>
        {/* <div>{JSON.stringify(row)}</div> */}
        <div style={{flex:1,display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
          <div style={{textAlign:'center',}}>{row.data[0]}</div> 
          {color && <div style={{width:9,height:9,background:color,borderRadius:100,marginLeft:5}}/>}
        </div>
        <div style={{flex:1,textAlign:'center'}}>{row.data.length} Periods</div>
        <div style={{flex:1,textAlign:'center',color:row.state=='Active'?'green':'red'}}>{row.state}</div>
          {/* {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>} */}
        </div>
    })}
  </div> 
  </>
}



export const WinGoFrequency:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
  const nums = useMemo(()=>{
    return [0,1,2,3,4,5,6,7,8,9]
  },[])
  const pics = useWingoPics()
  const flatPics = useWingoFlatPics()
  const ballPositionsRef = useRef([])
  const [showLine,setShowLine] = useState(false)
  useEffect(()=>{
    setShowLine(false)
    setTimeout(() => {
      setShowLine(true)
    }, 0);
  },[historyDrawResult])
  return <>
  <div style={{flexDirection:'column',display:'flex' }}>
    {/* <DragonHead/> */}
    {historyDrawResult?.map((row:any,index:number)=>{
      if(!row.content){
        return <></>
      }
      const num = row.content.number
      return <div style={{flexDirection:'row',display:'flex',flex:1,paddingTop:10,paddingBottom:10,background:index%2?'white':'#f9f9f9' }}>
        {/* <div>{JSON.stringify(row.content.premium)}</div> */}
        <div style={{flex:1,display:'flex',flexDirection:'row',justifyContent:'space-around',alignItems:'center',position:'relative'}}>

          <div style={{textAlign:'center',color:'gray',marginLeft:5,marginRight:5,fontSize:14}}>*{_.takeRight(row.issueNumber,6)}</div>
          <div style={{display:'flex',flexDirection:'row'}}>
          {nums.map(n=>{
            return <div  style={{marginRight:5,borderRadius:100,borderWidth:n==num?0:1,borderColor:'gray',color:'gray',width:15,height:15,textAlign:'center',alignItems:'center',justifyContent:'center',display:'flex'}}>
                
                {n==num? <img  className={'highlight'+index} src={flatPics[num]} ref={ref=>{
                    if(!ref){
                      return
                    }
                    console.log('ref',ref.x,ref.y,ref.width,'num',n,'index',index,ref.getBoundingClientRect())
                }} style={{width:'100%',height:'100%',zIndex:1}}/>: <span style={{fontSize:12}}>{n}</span>}
                
              </div>
          })}
          {showLine && <LineTo from={'highlight'+index} to={'highlight'+(index+1)} zIndex={0} borderColor={blue[900]}/>}
          </div> 
           <div style={{background:num>4?'orange':'#6EA8F4', color:'white',borderRadius:100,marginLeft:5,marginRight:5,minWidth:15,minHeight:15,display:'flex',alignItems:'center',justifyContent:'center',fontSize:10}}>{num>4?'B':'S'}</div>
         
        </div>
        {/* <div style={{flex:1,textAlign:'center'}}>{row.data.length} Periods</div> */}
        {/* <div style={{flex:1,textAlign:'center',color:row.state=='Active'?'green':'red'}}>{row.state}</div> */}
          {/* {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>} */}
        </div>
    })}
  </div> 
  </>
}


export const K3Frequency:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
  const nums = useMemo(()=>{
    return [1,2,3,4,5,6]
  },[])
  const pics = useWingoPics()
  const flatPics = useWingoFlatPics()
  const ballPositionsRef = useRef([])
  const [showLine,setShowLine] = useState(false)
  const positions = useMemo(()=>{
    return ['Dice 1','Dice 2','Dice 3']
  },[])
  const [selectedPosition,setSelectedPosition] = useState(0)
  useEffect(()=>{
    setShowLine(false)
    setTimeout(() => {
      setShowLine(true)
    }, 0);
  },[historyDrawResult,selectedPosition])
  return <>
  <div style={{flexDirection:'column',display:'flex' }}>
    <div style={{flexDirection:'row',display:'flex',padding:10,paddingBottom:0}}>
    {positions.map((p,i)=>{
      return <div style={{color:selectedPosition==i?blue[900]:'gray',marginRight:10,minWidth:20,position:'relative',textAlign:'center'}} onClick={()=>{
        setSelectedPosition(i)
        setShowLine(false)
      }}>{p}
        {selectedPosition==i && <div style={{position:'absolute',left:0,right:0,bottom:0,height:2,background:blue[900]}}/>}
      </div>
    })}
    </div>
    {/* <DragonHead/> */}
    {historyDrawResult?.map((row:any,index:number)=>{
      if(!row.content){
        return <></>
      }
      const num = row.content.premium[selectedPosition]
      return <div style={{flexDirection:'row',display:'flex',flex:1,paddingTop:10,paddingBottom:10,background:index%2?'white':'#f9f9f9' }}>
        {/* <div>{JSON.stringify(row.content.premium)}</div> */}
        {/* <div>{num}</div> */}
        <div style={{flex:1,display:'flex',flexDirection:'row',justifyContent:'space-around',alignItems:'center',position:'relative'}}>

          <div style={{textAlign:'center',color:'gray',marginLeft:5,marginRight:5}}>{row.issueNumber}</div>
          <div style={{display:'flex',flexDirection:'row'}}>
          {nums.map(n=>{
            return <div  style={{marginRight:5,borderRadius:100,borderWidth:n==num?0:1,background:n==num?blue[900]:'transparent', borderColor:'gray',color:'gray',width:20,height:20,textAlign:'center',alignItems:'center',justifyContent:'center',display:'flex'}}>
                  <span className={n==num?('highlight'+index):''} style={{zIndex:1,fontSize:13,color:n==num?'white':'gray'}}>{n}</span>
                
              </div>
          })}
          {showLine && <LineTo from={'highlight'+index} to={'highlight'+(index+1)} zIndex={0} borderColor={blue[900]}/>}
          </div> 
           {/* <div style={{background:blue[900], color:'white',borderRadius:100,marginLeft:5,marginRight:5,minWidth:20,minHeight:20,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13}}>{num>4?'B':'S'}</div> */}
         
        </div>
        {/* <div style={{flex:1,textAlign:'center'}}>{row.data.length} Periods</div> */}
        {/* <div style={{flex:1,textAlign:'center',color:row.state=='Active'?'green':'red'}}>{row.state}</div> */}
          {/* {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>} */}
        </div>
    })}
  </div> 
  </>
}


export const _5DFrequency:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
  const nums = useMemo(()=>{
    return [0,1,2,3,4,5,6,7,8,9]
  },[])
  const pics = useWingoPics()
  const flatPics = useWingoFlatPics()
  const ballPositionsRef = useRef([])
  const [showLine,setShowLine] = useState(false)
  const positions = useMemo(()=>{
    return ['A','B','C','D','E']
  },[])
  const [selectedPosition,setSelectedPosition] = useState(0)
  useEffect(()=>{
    setShowLine(false)
    setTimeout(() => {
      setShowLine(true)
    }, 0);
  },[historyDrawResult,selectedPosition])
  return <>
  <div style={{flexDirection:'column',display:'flex' }}>
    <div style={{flexDirection:'row',display:'flex',padding:10,paddingBottom:0}}>
    {positions.map((p,i)=>{
      return <div style={{color:selectedPosition==i?blue[900]:'gray',marginRight:10,minWidth:20,position:'relative',textAlign:'center'}} onClick={()=>{
        setSelectedPosition(i)
        setShowLine(false)
      }}>{p}
        {selectedPosition==i && <div style={{position:'absolute',left:0,right:0,bottom:0,height:2,background:blue[900]}}/>}
      </div>
    })}
    </div>
    {/* <DragonHead/> */}
    {historyDrawResult?.map((row:any,index:number)=>{
      if(!row.content){
        return <></>
      }
      const num = row.content.premium[selectedPosition]
      return <div style={{flexDirection:'row',display:'flex',flex:1,paddingTop:10,paddingBottom:10,background:index%2?'white':'#f9f9f9' }}>
        {/* <div>{JSON.stringify(row.content.premium)}</div> */}
        {/* <div>{num}</div> */}
        <div style={{flex:1,display:'flex',flexDirection:'row',justifyContent:'space-around',alignItems:'center',position:'relative'}}>

          <div style={{textAlign:'center',color:'gray',marginLeft:5,marginRight:5,fontSize:14}}>*{_.takeRight(row.issueNumber,6)}</div>
          <div style={{display:'flex',flexDirection:'row'}}>
          {nums.map(n=>{
            return <div  style={{marginRight:5,borderRadius:100,borderWidth:n==num?0:1,borderColor:'gray',color:'gray',width:15,height:15,textAlign:'center',alignItems:'center',justifyContent:'center',display:'flex'}}>
                
                {n==num? <img  className={'highlight'+index} src={flatPics[num]} ref={ref=>{
                    if(!ref){
                      return
                    }
                    console.log('ref',ref.x,ref.y,ref.width,'num',n,'index',index,ref.getBoundingClientRect())
                }} style={{width:'100%',height:'100%',zIndex:1}}/>: <span style={{fontSize:10}}>{n}</span>}
                
              </div>
          })}
          {showLine && <LineTo from={'highlight'+index} to={'highlight'+(index+1)} zIndex={0} borderColor={blue[900]}/>}
          </div> 
           <div style={{background:num>4?'orange':'#6EA8F4', color:'white',borderRadius:100,marginLeft:5,marginRight:5,minWidth:15,minHeight:15,display:'flex',alignItems:'center',justifyContent:'center',fontSize:10}}>{num>4?'B':'S'}</div>
         
        </div>
        {/* <div style={{flex:1,textAlign:'center'}}>{row.data.length} Periods</div> */}
        {/* <div style={{flex:1,textAlign:'center',color:row.state=='Active'?'green':'red'}}>{row.state}</div> */}
          {/* {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>} */}
        </div>
    })}
  </div> 
  </>
}

const DragonHead = ()=>{
  return <div style={{flexDirection:'row',display:'flex',flex:1,background:blue[100],paddingTop:10,paddingBottom:10 }}>
        <div style={{flex:1,textAlign:'center',color:'black'}}>Dragons Type</div>
        <div style={{flex:1,textAlign:'center',color:'black'}}>Length</div>
        <div style={{flex:1,textAlign:'center',color:'black'}}>Status</div>
    </div>
}

export const K3Dragons:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
   
  const bsResultArrayFinal = useMemo(()=>{
    if(!historyDrawResult){
      return
    }
    const [first,...restHistoryDrawResult] = historyDrawResult
    const bsResult = getChunk(restHistoryDrawResult.map(i=>i?.content?.sumCount>10?'Big':'Small'))
    const bsResultObject:{[key:string]:string[]} = {}
    bsResult.forEach((item,index)=>{
        if(item.length>=2){
          // @ts-ignore
          bsResultObject[index+''] = item
        }
    })
    
    console.log('bsResult',bsResultObject,)
    const bsResultArrayFinal:{state:string,data:string[]}[] = []
    Object.keys(bsResultObject).forEach((index:string)=>{
      bsResultArrayFinal.push({
        state:index==='0'?'Active':'Expired',
        data:bsResultObject[index]
      })
    })
    console.log('bsResultArrayFinal',bsResultArrayFinal)
    return _.take(bsResultArrayFinal,2)
  },[historyDrawResult])
 

  const greenRedResultArrayFinal = useMemo(()=>{
    if(!historyDrawResult){
      return
    }
    const [first,...restHistoryDrawResult] = historyDrawResult
    const bsResult =  getChunk(restHistoryDrawResult.map(i=>i?.content?.sumCount%2?'Odd':'Even'))
    const bsResultObject:{[key:string]:string[]} = {}
    bsResult.forEach((item,index)=>{
        if(item.length>=2){
          // @ts-ignore
          bsResultObject[index+''] = item
        }
    })
    
    console.log('bsResult',bsResultObject,)
    let bsResultArrayFinal:{state:string,data:string[]}[] = []
    Object.keys(bsResultObject).forEach((index:string)=>{
      bsResultArrayFinal.push({
        state:index==='0'?'Active':'Expired',
        data:bsResultObject[index]
      })
    })
    // bsResultArrayFinal = bsResultArrayFinal.filter(i=>i.data[0]!='null')
    console.log('purpleResultArrayFinal',bsResultArrayFinal)
    return _.take(bsResultArrayFinal,2)
  },[historyDrawResult])
  const arrayFinal = useMemo(()=>{
      if(!bsResultArrayFinal){
        return []
      } 
      if(!greenRedResultArrayFinal){
        return []
      }
      return [...bsResultArrayFinal,...greenRedResultArrayFinal].sort((a,b)=>{
        const valueA = a.state=='Active'?1:0
        const valueB = b.state=='Active'?1:0
        return valueB - valueA
      })
  },[bsResultArrayFinal,greenRedResultArrayFinal])
  return <>
  
  <div style={{flexDirection:'column',display:'flex'}}>
    <DragonHead/>
    {arrayFinal?.map((row:any,index:number)=>{
      return <div style={{flexDirection:'row',display:'flex',flex:1,paddingTop:10,paddingBottom:10,background:index%2?'white':'#f9f9f9' }}>
        {/* <div>{JSON.stringify(row)}</div> */}
        <div style={{flex:1,textAlign:'center'}}>{row.data[0]}</div>
        <div style={{flex:1,textAlign:'center'}}>{row.data.length} Periods</div>
        <div style={{flex:1,textAlign:'center',color:row.state=='Active'?'green':'red'}}>{row.state}</div>
          {/* {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>} */}
        </div>
    })}
  </div> 
  </>
}


const convertChunkToArrayFinal = (bsResult:string[][])=>{
    const bsResultObject:{[key:string]:string[]} = {}
    bsResult.forEach((item,index)=>{
        if(item.length>=2){
          // @ts-ignore
          bsResultObject[index+''] = item
        }
    })
    
    console.log('bsResult',bsResultObject,)
    const bsResultArrayFinal:{state:string,data:string[]}[] = []
    Object.keys(bsResultObject).forEach((index:string)=>{
      bsResultArrayFinal.push({
        state:index==='0'?'Active':'Expired',
        data:bsResultObject[index]
      })
    })
    console.log('bsResultArrayFinal',bsResultArrayFinal)
    return _.take(bsResultArrayFinal,2)
}

export const _5DDragons:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
   
  const [bsSumResultArrayFinal,bsAResultArrayFinal,bsBResultArrayFinal,bsCResultArrayFinal,bsDResultArrayFinal,bsEResultArrayFinal,] = useMemo(()=>{
    if(!historyDrawResult){
      return
    }
    const [first,...restHistoryDrawResult] = historyDrawResult
    const bsResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.sumCount>22?'SUM Big':'SUM Small')))
    const bsAResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[0]>4?'A Big':'A Small')))
    const bsBResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[1]>4?'B Big':'B Small')))
    const bsCResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[2]>4?'C Big':'C Small')))
    const bsDResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[3]>4?'D Big':'D Small')))
    const bsEResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[4]>4?'E Big':'E Small')))
 
    return [bsResult,bsAResult,bsBResult,bsCResult,bsDResult,bsEResult]
  },[historyDrawResult])
 

  const [oeSumResultArrayFinal,oeAResultArrayFinal,oeBResultArrayFinal,oeCResultArrayFinal,oeDResultArrayFinal,oeEResultArrayFinal] = useMemo(()=>{
    if(!historyDrawResult){
      return
    }
    const [first,...restHistoryDrawResult] = historyDrawResult
    const bsResult =  convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.sumCount%2?'SUM Odd':'SUM Even')))
    const bsAResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[0]%2?'A Odd':'A Even')))
    const bsBResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[1]%2?'B Odd':'B Even')))
    const bsCResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[2]%2?'C Odd':'C Even')))
    const bsDResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[3]%2?'D Odd':'D Even')))
    const bsEResult = convertChunkToArrayFinal(getChunk(restHistoryDrawResult.map(i=>i?.content?.premium.split('')[4]%2?'E Odd':'E Even')))

    return [bsResult,bsAResult,bsBResult,bsCResult,bsDResult,bsEResult]
  },[historyDrawResult])
  const arrayFinal = useMemo(()=>{
      if(!bsSumResultArrayFinal){
        return []
      } 
      if(!oeSumResultArrayFinal){
        return []
      }
      return [...bsSumResultArrayFinal,...bsAResultArrayFinal,...bsBResultArrayFinal,...bsCResultArrayFinal,...bsDResultArrayFinal,...bsEResultArrayFinal,
          ...oeSumResultArrayFinal,...oeAResultArrayFinal,...oeBResultArrayFinal,...oeCResultArrayFinal,...oeDResultArrayFinal,...oeEResultArrayFinal,].sort((a,b)=>{
        const valueA = a.state=='Active'?1:0
        const valueB = b.state=='Active'?1:0
        console.log('valueA',valueA,'valueB',valueB)
        return valueB - valueA
      })
  },[bsSumResultArrayFinal,bsAResultArrayFinal,bsBResultArrayFinal,bsCResultArrayFinal,bsDResultArrayFinal,bsEResultArrayFinal,
    oeSumResultArrayFinal,oeAResultArrayFinal,oeBResultArrayFinal,oeCResultArrayFinal,oeDResultArrayFinal,oeEResultArrayFinal])
  return <>
  
  <div style={{flexDirection:'column',display:'flex'}}>
    <DragonHead/>
    {arrayFinal?.map((row:any,index:number)=>{
      return <div style={{flexDirection:'row',display:'flex',flex:1,paddingTop:10,paddingBottom:10,background:index%2?'white':'#f9f9f9' }}>
        {/* <div>{JSON.stringify(row)}</div> */}
        <div style={{flex:1,textAlign:'center'}}>{row.data[0]}</div>
        <div style={{flex:1,textAlign:'center'}}>{row.data.length} Periods</div>
        <div style={{flex:1,textAlign:'center',color:row.state=='Active'?'green':'red'}}>{row.state}</div>
          {/* {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>} */}
        </div>
    })}
  </div> 
  </>
}

export const TrxWinGoRouteMap:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
  const chunkedDraws = useMemo(()=>{
    const [first,...rest] = historyDrawResult
    const res =  _.chunk(_.take(rest,72),6)
    console.log('res',res)
    return res
  },historyDrawResult)
  const wingoPics = useWingoPics()
  const zhupans = useMemo(()=>{
    const [first,...rest] = historyDrawResult
    const res =  _.take(rest,72)
    const columns:string[][] = []
    
    const route = getRoute(res.map(i=>i.content.number>4?'B':'S'))
    // for(let i =0;i<res.length;i++){
    //   const bs = res[i].content.number > 4?'b':'s'
    //   console.log('res[i]',res[i].content.number,bs,i)
      
    // }
    // getRoute
    const res1 = _.takeRight(route,24)
     
    console.log('res1',res1)
    return res1
  },[historyDrawResult])
  return <>
  <div style={{display:'flex',flexDirection:'row-reverse',padding:10,paddingBottom:0}}>
    {chunkedDraws.map((columnDraws,rowIndex)=>{
      return <div style={{display:'flex',flexDirection:'column-reverse',flex:1}}>{columnDraws.map((draw,columnIndex)=>{
        return <div style={{display:'flex',alignItems:'center',justifyContent:'center',flex:1,position:'relative'
        // borderLeftWidth:1,borderBottomWidth:1,borderColor:'lightgray',borderRightWidth:row==0?1:0,borderTopWidth:i==columnDraws.length-1?1:0
        }}>
           <img src={wingoPics[draw?.content?.number]} style={{width:'80%',height:'80%'}}/>
           {rowIndex===chunkedDraws.length-1&&<div style={{width:1,position:'absolute',left:0,bottom:0,top:0,background:'lightgray'}}/>}
           <div style={{width:1,position:'absolute',right:0,bottom:0,top:0,background:'lightgray'}}/>

           {columnIndex === columnDraws.length-1 && <div style={{height:1,position:'absolute',left:0,top:0,right:0,background:'lightgray'}}/>}
           <div style={{height:1,position:'absolute',left:0,bottom:0,right:0,background:'lightgray'}}/>
          </div>
      })}</div> 
    })}
    
  </div> 
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingTop:0}}>
    {zhupans.map((column,columnIndex)=>{
      return <div style={{flexDirection:'column',display:'flex',flex:1,position:'relative'}}>
          {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
        </div>
    })}
  </div> 
  </>
}


const DiceStatistics:React.FC<{data:string[],title?:string}> = ({data,title='ab'})=>{
  const nums = useMemo(()=>{
    return new Array(6).fill(0)
  },[])
  const statistics = useMemo(()=>{
    return nums.map((n,index)=>{
      // const res:{missing?:number,avgMissing?:number,frequency?:number,maxConsecutive?:number} = {}
      let numCount = 0
      const numPositions:number[] = []
      data.forEach((item)=>{
        if(parseInt(item)===index+1){
          numCount++
        }
      })
      
      return numCount   
    })
  },[data])
  return <div style={{display:'flex',flexDirection:'column',width:'100%'}}>
    <div style={{textAlign:'center',padding:5,background:'#f9f9f9',position:'relative'}}>
      {title}
      <div style={{position:'absolute',left:0,right:0,top:0,height:1,background:'lightgray',}}/>
      <div style={{position:'absolute',left:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
      <div style={{position:'absolute',right:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
    </div>
    <div style={{display:'flex',flexDirection:'row',width:'100%',position:'relative',color:'gray'}}>
      
      <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'lightgray'}}/>
      <div style={{position:'absolute',left:0,right:0,top:0,height:1,background:'lightgray',}}/>
        
        {nums.map((n,index,arr)=>{
          return <div style={{flexDirection:'column',position:'relative',textAlign:'center',flex:1}}>
                <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>
                <div style={{}}>
                  {/* {index} */}
                  <div style={{color:'gray'}}>{index+1}</div>
                </div>
                <div style={{height:1,width:'100%',background:'lightgray'}}/>
                <div style={{marginLeft:2,marginRight:2,color:blue[900]}}>{statistics[index]}</div> 
                {index==arr.length-1&&<div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
            </div>
        })}
    </div>
  </div>
}

const DecimalStatistics:React.FC<{data:string[],colorBall?:boolean}> = ({data,colorBall=false})=>{
    const nums = useMemo(()=>{
      return new Array(10).fill(0)
    },[])
    const statistics = useMemo(()=>{
      return nums.map((n,index)=>{
        const res:{missing?:number,avgMissing?:number,frequency?:number,maxConsecutive?:number} = {}
        const num = index 
        res.missing =   _.indexOf(data,num+'')
        // console.log('data',data,'index',index)
        const numPositions:number[] = []
        data.forEach((item,index)=>{
          if(parseInt(item)===num){
            numPositions.push(index)
          }
        })
        const adjacentPositions:number[] = []
        numPositions.forEach((numPosition,index)=>{
          const nextNumPosition = numPositions[index+1]
          if(nextNumPosition){
            adjacentPositions.push(nextNumPosition-numPosition)
          }
        })
        res.frequency = numPositions.length
        if(adjacentPositions.length>0 && res.frequency>0){
          // res.avgMissing = adjacentPositions.reduce((pv,cv)=>pv+cv,0)/adjacentPositions.length
          res.avgMissing = Math.floor((data.length - res.frequency)/res.frequency)
        } 
        
        
        res.maxConsecutive = adjacentPositions.map(i=>i==1?1:'_').join('').split('_').sort((a,b)=>-a.length+b.length)[0].length + 1
        console.log('adjacentPositions',adjacentPositions,res.maxConsecutive,'for num',index,'numPositions',numPositions)
        // res.missing = _.lastIndexOf(data,num)
        return res   
      })
    },[data])
    const wingoPics = useWingoFlatPics()
    return <div style={{display:'flex',flexDirection:'row',width:'100%',position:'relative',color:'gray'}}>
       <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'lightgray'}}/>
       <div style={{position:'absolute',left:0,right:0,top:0,height:1,background:'lightgray',}}/>
        <div style={{flexDirection:'column',flex:1,textAlign:'left',position:'relative',display:'flex'}}>
            <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>
            <div style={{marginLeft:10,fontSize:12,flex:1,display:'flex',overflow:'hidden', alignItems:'center',justifyContent:'flex-start',height:19}}>
              <span style={{display:'-webkit-box',WebkitBoxOrient:'vertical',WebkitLineClamp:1,}}>Winning Numbers</span>
            </div>
            <div style={{height:1,width:'100%',background:'lightgray'}}/>
            <div style={{marginLeft:10,fontSize:12,flex:1,display:'flex',alignItems:'center',justifyContent:'flex-start'}}>Missing</div>
            <div style={{height:1,width:'100%',background:'lightgray'}}/>
            <div style={{marginLeft:10,fontSize:12,flex:1,display:'flex',alignItems:'center',overflow:'hidden',justifyContent:'flex-start'}}>
              <span style={{display:'-webkit-box',WebkitBoxOrient:'vertical',WebkitLineClamp:1,}}>Avg missing</span>
            </div>
            <div style={{height:1,width:'100%',background:'lightgray'}}/>
            <div style={{marginLeft:10,fontSize:12,flex:1,display:'flex',alignItems:'center',overflow:'hidden',justifyContent:'flex-start'}}>
              <span style={{display:'-webkit-box',WebkitBoxOrient:'vertical',WebkitLineClamp:1,}}>Frequency</span>
            </div>
            <div style={{height:1,width:'100%',background:'lightgray'}}/>
            <div style={{marginLeft:10,fontSize:12,flex:1,display:'flex',overflow:'hidden',alignItems:'center',justifyContent:'flex-start'}}>
              <span style={{display:'-webkit-box',WebkitBoxOrient:'vertical',WebkitLineClamp:1,}}>Max Consecutive</span>
            </div> 
        </div>
        {nums.map((n,index,arr)=>{
          return <div style={{flexDirection:'column',position:'relative',textAlign:'center',display:'flex'}}>
                <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>
                <div style={{display:'flex',alignItems:'center',justifyContent:'center',flex:1, }}>
                  {/* {index} */}
                  {/* fad */}
                  <div style={{  fontSize:11,color:'white',alignItems:'center',justifyContent:'center',height:19,padding:1}}>
                    {colorBall?<img src={wingoPics[index]} style={{width:17,height:17}}/>:<div style={{background:colorBall?'transparent':blue[900],width:17,borderRadius:100,overflow:'hidden',}}>{index}</div>}
                  </div>
                </div>
                <div style={{height:1,width:'100%',background:'lightgray'}}/>
                <div style={{marginLeft:1,marginRight:1,fontSize:12,position:'relative',flex:1}}>{statistics[index].missing}</div>
                <div style={{height:1,width:'100%',background:'lightgray'}}/>
                <div style={{marginLeft:2,marginRight:2,fontSize:12,flex:1}}>{Math.ceil(statistics[index].avgMissing)}</div>
                <div style={{height:1,width:'100%',background:'lightgray'}}/>
                <div style={{marginLeft:2,marginRight:2,fontSize:12,flex:1}}>{statistics[index].frequency}</div>
                <div style={{height:1,width:'100%',background:'lightgray'}}/>
                <div style={{marginLeft:2,marginRight:2,fontSize:12,flex:1}}>{statistics[index].maxConsecutive}</div>
                {index==arr.length-1&&<div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
            </div>
        })}
    </div>
}


export const WinGoStatistics:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  const draw = useMemo(()=>{
    if(!historyDrawResult){
      return []
    }
    const [first,...rest] = historyDrawResult
    return rest;
  },[historyDrawResult])
  return <>
  <div style={{color:'black',padding:10,background:blue[100]}}>Last 100 Periods</div>
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingTop:10}}>
    <DecimalStatistics data={draw?.map(i=>i.content.number)} colorBall/>
  </div> 
  </>
}


export const K3Statistics:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  const draw = useMemo(()=>{
    if(!historyDrawResult){
      return []
    }
    const [first,...rest] = historyDrawResult
    return rest;
  },[historyDrawResult])
  return <>
  <div style={{color:'black',padding:10,background:blue[100]}}>Last 100 Periods</div>
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingTop:10}}>
    <DiceStatistics data={draw?.map(i=>i.content.premium[0])} title='Dice 1 Appearing'/>
  </div> 
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingTop:0}}>
    <DiceStatistics data={draw?.map(i=>i.content.premium[1])} title='Dice 2 Appearing'/>
  </div> 
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingTop:0}}>
    <DiceStatistics data={draw?.map(i=>i.content.premium[2])} title='Dice 3 Appearing'/>
  </div> 
  </>
}


export const _5DStatistics:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  const draw = useMemo(()=>{
    if(!historyDrawResult){
      return []
    }
    const [first,...rest] = historyDrawResult
    return rest;
  },[historyDrawResult])
  return <>
  <div style={{color:'black',padding:10,background:blue[100]}}>Last 100 Periods</div>
  <div style={{flexDirection:'column',display:'flex',paddingTop:10,padding:10}}>
    <div style={{position:'relative',textAlign:'center',background:'#f9f9f9'}}>
       A
      <div style={{position:'absolute',left:0,right:0,top:0,height:1,background:'lightgray',}}/>
      <div style={{position:'absolute',left:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
      <div style={{position:'absolute',right:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
    </div>
    <DecimalStatistics data={draw?.map(i=>i.content.premium[0])} />
  </div> 
  <div style={{flexDirection:'column',display:'flex',padding:10,paddingTop:0,}}>
    <div style={{position:'relative',textAlign:'center',background:'#f9f9f9'}}>
       B
      <div style={{position:'absolute',left:0,right:0,top:0,height:1,background:'lightgray',}}/>
      <div style={{position:'absolute',left:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
      <div style={{position:'absolute',right:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
    </div>
    <DecimalStatistics data={draw?.map(i=>i.content.premium[1])} />
  </div> 
  <div style={{flexDirection:'column',display:'flex',padding:10,paddingTop:0,}}>
    <div style={{position:'relative',textAlign:'center',background:'#f9f9f9'}}>
       C
      <div style={{position:'absolute',left:0,right:0,top:0,height:1,background:'lightgray',}}/>
      <div style={{position:'absolute',left:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
      <div style={{position:'absolute',right:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
    </div>
    <DecimalStatistics data={draw?.map(i=>i.content.premium[2])} />
  </div> 
  <div style={{flexDirection:'column',display:'flex',padding:10,paddingTop:0}}>
    <div style={{position:'relative',textAlign:'center',background:'#f9f9f9'}}>
       D
      <div style={{position:'absolute',left:0,right:0,top:0,height:1,background:'lightgray',}}/>
      <div style={{position:'absolute',left:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
      <div style={{position:'absolute',right:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
    </div>
    <DecimalStatistics data={draw?.map(i=>i.content.premium[3])} />
  </div> 
  <div style={{flexDirection:'column',display:'flex',padding:10,paddingTop:0}}>
    <div style={{position:'relative',textAlign:'center',background:'#f9f9f9'}}>
       E
      <div style={{position:'absolute',left:0,right:0,top:0,height:1,background:'lightgray',}}/>
      <div style={{position:'absolute',left:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
      <div style={{position:'absolute',right:0,bottom:0,top:0,width:1,background:'lightgray',}}/>
    </div>
    <DecimalStatistics data={draw?.map(i=>i.content.premium[4])} />
  </div> 
  
  </>
}


export const K3RouteMap:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
  const chunkedDraws = useMemo(()=>{
    const [first,...rest] = historyDrawResult
    const res =  _.chunk(_.take(rest,72),6)
    console.log('res',res)
    return res
  },historyDrawResult)
  const wingoPics = useWingoPics()
  const positions = useMemo(()=>{
    // return ['Dice 1','Dice 2','Dice 3','SUM']
    return []
  },[])
  const [selectedPosition,setSelectedPosition] = useState(0)
  const {bsRoute,oeRoute} = useMemo(()=>{
    const [first,...rest] = historyDrawResult
    const res =  _.take(rest,72)
    const columns:string[][] = []
    
    let bsRoute = getRoute(res.map(i=>{
      // if(selectedPosition<3){
      //   return parseInt(i.content.premium.split('')[selectedPosition])>3?'B':'S'
      // }else{
      //   return i.content.sumCount>10?'B':'S'
      // }
        return i.content.sumCount>10?'B':'S'
    }))
    let oeRoute = getRoute(res.map(i=>{
      // if(selectedPosition<3){
      //   return parseInt(i.content.premium.split('')[selectedPosition])%2?'O':'E'
      // }else{
      //   return i.content.sumCount%2?'O':'E'
      // }
      return i.content.sumCount%2?'O':'E'
  }))
    // for(let i =0;i<res.length;i++){
    //   const bs = res[i].content.number > 4?'b':'s'
    //   console.log('res[i]',res[i].content.number,bs,i)
      
    // }
    // getRoute
    bsRoute = _.takeRight(bsRoute,24)
    oeRoute = _.takeRight(oeRoute,24)
     
    // console.log('res1',res1)
    return {bsRoute,oeRoute}
  },[historyDrawResult,selectedPosition])
  return <>
    {/* <div style={{flexDirection:'row',display:'flex',padding:10,paddingBottom:0}}>
    {positions.map((p,i)=>{
      return <div style={{color:selectedPosition==i?blue[900]:'gray',marginRight:10,minWidth:20,position:'relative',textAlign:'center'}} onClick={()=>{
        setSelectedPosition(i)
        // setShowLine(false)
      }}>{p}
        {selectedPosition==i && <div style={{position:'absolute',left:0,right:0,bottom:0,height:2,background:blue[900]}}/>}
      </div>
    })}
    </div> */}
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingBottom:0}}>
    {bsRoute.map((column,columnIndex)=>{
      return <div style={{flexDirection:'column',display:'flex',flex:1,position:'relative'}}>
          {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}

              {rowIndex==0 && <div style={{position:'absolute',top:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {/* {rowIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>} */}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
        </div>
    })}
  </div> 
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingTop:0}}>
    {oeRoute.map((column,columnIndex)=>{
      return <div style={{flexDirection:'column',display:'flex',flex:1,position:'relative'}}>
          {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='O'?'#FB5B5B': c=='E'?'#18B660':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
        </div>
    })}
  </div> 
  </>
}


export const _5DRouteMap:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  // 12*6
  const chunkedDraws = useMemo(()=>{
    const [first,...rest] = historyDrawResult
    const res =  _.chunk(_.take(rest,72),6)
    console.log('res',res)
    return res
  },historyDrawResult)
  
 
  const positions = useMemo(()=>{
    return ['A','B','C','D','E','SUM']
  },[])
  const [selectedPosition,setSelectedPosition] = useState(0)

  const {bsRoute,oeRoute} = useMemo(()=>{
    const [first,...rest] = historyDrawResult
    const res =  _.take(rest,72) 
     
    let bsRoute = getRoute(res.map(i=>{
      return selectedPosition<5?  (parseInt(i.content.premium.split('')[selectedPosition])>4?'B':'S'):
       (i.content.sumCount>22?'B':'S')
    }))
    let oeRoute = getRoute(res.map(i=>{
      // i.content.sumCount%2?'O':'E'
      return selectedPosition<5?  (parseInt(i.content.premium.split('')[selectedPosition])%2?'O':'E'):
       (i.content.sumCount%2?'O':'E')
    }))
    // for(let i =0;i<res.length;i++){
    //   const bs = res[i].content.number > 4?'b':'s'
    //   console.log('res[i]',res[i].content.number,bs,i)
      
    // }
    // getRoute
    bsRoute = _.takeRight(bsRoute,24)
    oeRoute = _.takeRight(oeRoute,24)
     
    // console.log('res1',res1)
    return {bsRoute,oeRoute}
  },[historyDrawResult,selectedPosition])
  return <>
    <div style={{flexDirection:'row',display:'flex',padding:10,paddingBottom:0}}>
    {positions.map((p,i)=>{
      return <div style={{color:selectedPosition==i?blue[900]:'gray',marginRight:10,minWidth:20,position:'relative',textAlign:'center'}} onClick={()=>setSelectedPosition(i)}>{p}
        {selectedPosition==i && <div style={{position:'absolute',left:0,right:0,bottom:0,height:2,background:blue[900]}}/>}
      </div>
    })}
    </div>
    <div style={{display:'flex',flexDirection:'row-reverse',padding:10,paddingBottom:0}}>
        {chunkedDraws.map((columnDraws,rowIndex)=>{
          return <div style={{display:'flex',flexDirection:'column-reverse',flex:1}}>{columnDraws.map((draw,columnIndex)=>{
            return <div style={{display:'flex',alignItems:'center',justifyContent:'center',flex:1,position:'relative'
            // borderLeftWidth:1,borderBottomWidth:1,borderColor:'lightgray',borderRightWidth:row==0?1:0,borderTopWidth:i==columnDraws.length-1?1:0
            }}>
              <div style={{display:'flex',alignItems:'center',padding:3, justifyContent:'center',   }}>
                <div style={{width:17,height:17,fontSize:12,margin:0,background:blue[900],textAlign:'center', color:'white',borderRadius:100}}>{selectedPosition<5? (draw.content.premium.split('')[selectedPosition]):draw.content.sumCount}</div>
              </div>
              {rowIndex===chunkedDraws.length-1&&<div style={{width:1,position:'absolute',left:0,bottom:0,top:0,background:'lightgray'}}/>}
              <div style={{width:1,position:'absolute',right:0,bottom:0,top:0,background:'lightgray'}}/>

              {columnIndex === columnDraws.length-1 && <div style={{height:1,position:'absolute',left:0,top:0,right:0,background:'lightgray'}}/>}
              <div style={{height:1,position:'absolute',left:0,bottom:0,right:0,background:'lightgray'}}/>
              </div>
          })}</div> 
        })} 
        
      </div> 
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingBottom:0,paddingTop:0}}>
    {bsRoute.map((column,columnIndex)=>{
      return <div style={{flexDirection:'column',display:'flex',flex:1,position:'relative'}}>
          {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='B'?'#F5A036': c=='S'?'#6DA7F4':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}

              {/* {rowIndex==0 && <div style={{position:'absolute',top:0,left:0,right:0,height:1,background:'lightgray'}}/>} */}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {/* {rowIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>} */}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
        </div>
    })}
  </div> 
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingTop:0}}>
    {oeRoute.map((column,columnIndex)=>{
      return <div style={{flexDirection:'column',display:'flex',flex:1,position:'relative'}}>
          {column?.map((c,rowIndex)=>{
            return <div style={{flex:1,display:'flex',height:'100%',position:'relative', alignItems:'center',justifyContent:'center'}}>
              <div style={{background:c=='O'?'#FB5B5B': c=='E'?'#18B660':'transparent',borderRadius:100, width:'80%',margin:1, fontSize:8,textAlign:'center',color:'white'}}>{c?c:'　'}</div>
              {rowIndex%2!==0 && <div style={{position:'absolute',bottom:0,left:0,right:0,height:1,background:'lightgray'}}/>}
            </div>
          })}
          {columnIndex === 0 && <div style={{position:'absolute',left:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
          {columnIndex%2!==0 && <div style={{position:'absolute',right:0,top:0,bottom:0,width:1,background:'lightgray'}}/>}
        </div>
    })}
  </div> 
  </>
}

export const K3DrawHistory:React.FC<{historyDrawResult:any}> = ({historyDrawResult})=>{
  const lotteryPics = useMemo(()=>{
    return [kn1,kn2,kn3,kn4,kn5,kn6];
  },[])

  const {t} = useTranslation()
  const tabs = useMemo(()=>{
    return ['Basic','Advance']
  },[])
  const [selectedTabIndex,setSelectedTabIndex] = useState(0)
  return <>
    <div style={{display:'flex',flexDirection:'row',padding:10,paddingLeft:10}}>
      {tabs.map((t,index)=><div style={{position:'relative',marginRight:10,color:index==selectedTabIndex?blue[900]:'gray'}} onClick={()=>setSelectedTabIndex(index)}>
        {t}
        {index == selectedTabIndex && <div style={{position:'absolute',left:0,right:0,bottom:0,height:2,background:blue[900]}}/>}
      </div>)}
    </div>
      <div style={{background:blue[100],display:'flex',flexDirection:'row',padding:0,paddingTop:10,paddingBottom:10 }}>
            <div style={{flex:2,color:'black',textAlign:'center' }}>
              {t('Period')}
            </div>
            <div style={{flex:1,color:'black',textAlign:'center' }}>
              {'Time'}
            </div>
            {/* <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('B/S')}
            </div> */}
            {/* <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold'}}>
              O/E
            </div> */}
            <div style={{flex:2,color:'black',textAlign:'center' }}>
              {t('Result')}
            </div>
          </div>
          {historyDrawResult.map((item:any,index:number)=>{
            if(!item){
              return <></>
            }
            const number = parseInt(item.content?.number)
            const plan = item.plan 
            const hits = hit(item)
            // if(plan && item.content){
            //     if(plan.content.bs === 'b' && item.content.sumCount>9){
            //       bshit = true
            //     }
            //     if(plan.content.bs === 's' && item.content.sumCount<=9){
            //       bshit = true
            //     }
            // }
            // let oehit = false
            // if(plan && item.content){
            //     if(plan.content.oe === 'e' && item.content.sumCount%2){
            //       oehit = true
            //     }
            // }
            return  <div style={{background:index%2?'white':'#f9f9f9',display:'flex',flexDirection:'row',flex:1,position:'relative',padding:0}}>
            <div style={{flex:2,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',padding:10}}>
              {/* *{_.takeRight(item.issueNumber,6).join('')} */}
              {item.issueNumber}
            </div>
            <div style={{flex:1,color:'black',textAlign:'center', display:'flex',alignItems:'center',justifyContent:'center'}}>
              {/* <span style={{color:item.content?.sumCount%2?'green':'orange',fontWeight:'bold',fontSize:item.content?30:10}}>{item.content?item.content.sumCount:''}</span> */}
              {item.createTime ? new Date(item.createTime).toLocaleTimeString():t('Pending')}
            </div>
            {/* <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',padding:item.content?0:10}}>
              <span>{!item.content?t('Pending'):(item.content.sumCount>9?t('Big'):t('Small'))}
              {hits && <span style={{color:'white',fontSize:10,background:'red',borderRadius:2,paddingLeft:2,paddingRight:2,marginLeft:2}} >Hit</span>}
              </span>
              {plan && <span style={{fontSize:10}}>Plan:{plan.content.bs==='b'?t('Big'):t('Small')}</span>}
            </div>  */}
            <div style={{flex:2,color:'black',textAlign:'center',fontWeight:'normal',display:'flex',alignItems:'center',justifyContent:'center'}}>
              {selectedTabIndex==0 ? 
                  !item.content?'':item.content?.premium.split('').map((num:string)=>{
                  return <img src={lotteryPics[parseInt(num)-1]} style={{width:20,height:20,marginLeft:10}} alt=''/>})
                :''
              }
              {selectedTabIndex==1 ?
                 !item.content?'':<>
                      <span style={{width:20,height:20,background:item.content.sumCount>10?'#FEAA57':'#6EA8F4',color:'white',borderRadius:100,marginRight:5,fontSize:13}}>{item.content.sumCount>10?'B':'S'}</span>
                      <span style={{width:20,height:20,background:item.content.sumCount%2?'#FB5B5B':'#18B660',color:'white',borderRadius:100,marginRight:5,fontSize:13}}>{item.content.sumCount%2?'O':'E'}</span>
                      <span style={{width:20,height:20,background:'#3478FE',color:'white',borderRadius:100,marginRight:5,fontSize:13}}>{item.content.sumCount}</span>
                    </>:
              ''}
            </div>
            <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'#efefef'}}/>
          </div>
          })}
  </>
}

export const _5DDrawHistory:React.FC<{historyDrawResult:any}> = ({historyDrawResult,})=>{
  const {t} = useTranslation()
  const positions = useMemo(()=>{
    return ['Basic','A','B','C','D','E','SUM']
  },[])
  const [selectedPosition,setSelectedPosition] = useState(0)
   
    
  return <>
  <div style={{flexDirection:'row',display:'flex',padding:10,paddingBottom:0}}>
    {positions.map((p,i)=>{
      return <div style={{color:selectedPosition==i?blue[900]:'gray',marginRight:10,minWidth:20,position:'relative',textAlign:'center'}} onClick={()=>{
        setSelectedPosition(i)
        // setShowLine(false)
      }}>{p}
        {selectedPosition==i && <div style={{position:'absolute',left:0,right:0,bottom:0,height:2,background:blue[900]}}/>}
      </div>
    })}
    </div>
      <div style={{background:'transparent',display:'flex',flexDirection:'row',borderTopLeftRadius:10,borderTopRightRadius:10,marginTop:10,}}>
              <div style={{display:'flex',flexDirection:'row',background:blue[100],flex:1,borderRadius:0,paddingTop:10,paddingBottom:10}}>
                <div style={{flex:1,color:'black',textAlign:'center' }}>
                  {t('Period')}
                </div>
              
                {/* <div style={{flex:2,color:'black',textAlign:'center' }}>
                {t('Number')}
                </div> */}
                <div style={{flex:1,color:'black',textAlign:'center' }}>
                {/* {t('Sum')} */}
                Time
                </div>
                <div style={{flex:1,color:'black',textAlign:'center'}}>
                  {/* {t('B/S')} */}
                  Result
                </div>
                {/* <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold'}}>
                  O/E
                </div> */}
              </div>
              </div>
              {historyDrawResult.map((item:any,index:number)=>{
                if(!item){
                  return <></>
                }
                // const number = parseInt(item.content.number)
                // const plan = item.plan;
                // const hits = hit(item);
                const ball = item.content?.premium.split('')[selectedPosition-1]||item.content?.sumCount
                let bs,oe
                if(ball){
                  if(selectedPosition<6){
                    bs = ball>4?'B':'S'
                  }else{
                    bs = ball>22?'B':'S'
                  }
                  oe = ball%2?'O':'E'
                }
                return  <div style={{background:index%2?'white':'#f9f9f9',display:'flex',flexDirection:'row',flex:1,position:'relative',padding:0,paddingTop:10,paddingBottom:10,}}>
                <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',paddingLeft:10}}>
                  **{item.issueNumber.substring(6,17)}
                </div>
              
                {/* <div style={{flex:2,textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>
                
                </div> */}
                <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  {/* {!item.content? '':item.content.sumCount} */}
                  {item.createTime?new Date(item.createTime).toLocaleTimeString():''}
                </div>
                <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'row'}}>
                {/* <span>{!item.content?t('Pending'):(item.content.sumCount>22?t('Big'):t('Small'))}
                  {hits && <span style={{color:'white',fontSize:10,background:'red',borderRadius:2,paddingLeft:2,paddingRight:2,marginLeft:2}} >Hit</span>}
                </span>
                  {plan && <span style={{fontSize:10}}>Plan:{plan.content.bs==='b'?t('Big'):t('Small')}</span>} */}
                    {!item.content? t('Pending'): 
                    // basic
                    selectedPosition==0?item.content.premium.split('').map((num:string)=>{
                        return <div style={{borderRadius:50,color:'white',background:blue[900],width:20,height:20,display:'flex',alignItems:'center',justifyContent:'center',marginRight:5}}>{num}</div>
                      }):<>
                      {/*  a b c d e sum */}
                      <div style={{borderRadius:50,color:'white',background:bs=='B'?'#FEAA57':'#6EA8F4',width:20,height:20,display:'flex',alignItems:'center',justifyContent:'center',marginRight:5}}>
                        {bs}
                      </div>
                      <div style={{borderRadius:50,color:'white',background:oe=='O'?'#FB5B5B':'#18B660',width:20,height:20,display:'flex',alignItems:'center',justifyContent:'center',marginRight:5}}>
                        {oe}
                      </div>
                      <div style={{borderRadius:50,color:'white',background:blue[900],width:20,height:20,display:'flex',alignItems:'center',justifyContent:'center',marginRight:5}}>
                        {ball}
                      </div>
                      </>      
                  }
                </div>
                {/* <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  {!item.content? '':item.content.sumCount%2?'Even':'Odd'}
                </div> */}
                {/* <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'#efefef'}}/> */}
              </div>
              })}
  </>
} 

export const TrxWinGoDrawHistory:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  return <>
        <div style={{background:blue[100],display:'flex',flexDirection:'row',borderTopLeftRadius:10,borderTopRightRadius:10,padding:10,}}>
          <div style={{flex:2,color:'black',textAlign:'center'}}>
            {t('Period')}
          </div>
          <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('Block')}
          </div>
          <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('Time')}
          </div>
          <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('Hash')}
          </div>
          <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('Result')}
          </div>
        </div>
        {historyDrawResult.map((item:any,index:number)=>{
          if(!item){
            return <></>
          }
          const number = parseInt(item.content?.number) 
          const plan = item.plan
          const hits = hit(item)
          return  <div style={{background:index%2?'white':'#f9f9f9',display:'flex',flexDirection:'row',flex:1,position:'relative',padding:0,fontSize:14,paddingTop:10,paddingBottom:10 }}>
          <div style={{flex:2,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>
            **{item.issueNumber.substring(6,17)}
          </div>
          <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <span style={{color:'black',fontWeight:'normal', }}>{!item.content?'Pending':item.content.blockNumber}</span>
          </div>
          <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <span style={{color:'black',fontWeight:'normal'}}>{!item.content?'':item.content.blockTime?.split(' ')[1]}</span>
          </div>
          <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <span style={{color:'black',fontWeight:'normal'}}>{!item.content?'':('**'+item.content.blockID.substring(59,64))}</span>
          </div>
          <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
              <span>
                {!item.content? t('Pending') : (number>=5?t('Big'):t('Small')) }
                {hits && <span style={{color:'white',fontSize:10,background:'red',borderRadius:2,paddingLeft:2,paddingRight:2,marginLeft:2}} >{hits?'Hit':''}</span>}
              </span>
              {plan && <span style={{fontSize:10}}>Plan:{plan.content.bs=='b'?t('Big'):t('Small')}</span>}
          </div>
        
          <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'#efefef'}}/>
        </div>
      })}
    </>
} 

const LotteryDrawHistory:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const game = useCurrentGame()
  const {t} = useTranslation(['global'])
  const tabs = useMemo(()=>{
    return [{
      title:'Draws', 
    },{
      title:'Dragons', 
    },{
      title:'Frequency', 
    },{
      title:'Route', 
    },{
      title:'Statistics', 
    }]
  },[])
  const [selectedTabIndex,setSelectedTabIndex] = useState(0)

  const drawHistory = useMemo(()=>{
    if(game === 'wingo'){
      return <WinGoDrawHistory historyDrawResult={historyDrawResult}/>
    }
    if(game === 'k3'){
      return <K3DrawHistory historyDrawResult={historyDrawResult}/>
    }
    if(game === '5d'){
      // @ts-ignore
      return <_5DDrawHistory historyDrawResult={historyDrawResult}/>
    }
    if(game === 'trxwingo'){
      return <TrxWinGoDrawHistory historyDrawResult={historyDrawResult}/>
    }
  },[historyDrawResult,game])

  const routeMap = useMemo(()=>{
    if(game === 'wingo'){
      return <WinGoRouteMap historyDrawResult={historyDrawResult}/>
    }
    if(game === 'k3'){
      return <K3RouteMap historyDrawResult={historyDrawResult}/>
    }
    if(game === '5d'){
      // @ts-ignore
      return <_5DRouteMap historyDrawResult={historyDrawResult}/>
    }
    if(game === 'trxwingo'){
      return <WinGoRouteMap historyDrawResult={historyDrawResult}/>
    }
  },[historyDrawResult,game])

  const dragons = useMemo(()=>{
    if(game === 'wingo'){
      return <WinGoDragons historyDrawResult={historyDrawResult}/>
    }
    if(game === 'k3'){
      return <K3Dragons historyDrawResult={historyDrawResult}/>
    }
    if(game === '5d'){
      // @ts-ignore
      return <_5DDragons historyDrawResult={historyDrawResult}/>
    }
    if(game === 'trxwingo'){
      return <WinGoDragons historyDrawResult={historyDrawResult}/>
    }
  },[historyDrawResult,game])

  const frequency = useMemo(()=>{
    if(game === 'wingo'){
      return <WinGoFrequency historyDrawResult={historyDrawResult}/>
    }
    if(game === 'k3'){
      return <K3Frequency historyDrawResult={historyDrawResult}/>
    }
    if(game === '5d'){
      // @ts-ignore
      return <_5DFrequency historyDrawResult={historyDrawResult}/>
    }
    if(game === 'trxwingo'){
      return <WinGoFrequency historyDrawResult={historyDrawResult}/>
    }
  },[historyDrawResult,game])

  const statistics = useMemo(()=>{
    if(game === 'wingo'){
      return <WinGoStatistics historyDrawResult={historyDrawResult}/>
    }
    if(game === 'k3'){
      return <K3Statistics historyDrawResult={historyDrawResult}/>
    }
    if(game === '5d'){
      // @ts-ignore
      return <_5DStatistics historyDrawResult={historyDrawResult}/>
    }
    if(game === 'trxwingo'){
      return <WinGoStatistics historyDrawResult={historyDrawResult}/>
    }
  },[historyDrawResult,game])
  const textFont = useMemo(()=>{
    if(document.body.clientWidth>=400){
      return 12
    }
    return 10
  },[])
  if(!game){
    return <></>
  }
  
  if(historyDrawResult){
    // console.log('historyDrawResult[0]',historyDrawResult[1])
    if(historyDrawResult.length===0 || historyDrawResult[1].lottery?.toLowerCase() !== game){
        return <ClipLoader color={blue[900]} size={30} />
    }
  }
 
  
  return <>
    <div style={{flexDirection:'row',display:'flex',background:'#f9f9f9',justifyContent:'space-between',width:'100%',paddingLeft:10,paddingRight:10,paddingBottom:13,marginTop:3}}>
      {tabs.map((tab,index,arr)=>{
        const selected = index == selectedTabIndex
        return <div onClick={()=>setSelectedTabIndex(index)} style={{ background:selected? blue[100] :'white',color:selected?blue[900]:'gray',fontWeight:'bold', boxShadow:'0px 4px 6px rgba(11, 24, 50, 0.12)', borderWidth:1,flex:1,marginRight:index!=arr.length-1? 5:0,borderColor:selected?blue[900]:'transparent', display:'flex',alignItems:'center',justifyContent:'center',padding:5,fontSize:textFont,borderRadius:5}}>
            {tab.title}
          </div>
      })}
    </div>
    <div style={{paddingLeft:10,paddingRight:10,background:'#f9f9f9',width:'100%'}}>
      <div style={{background:'white',borderRadius:10,boxShadow:'0px 4px 6px rgba(11, 24, 50, 0.12)',overflow:'hidden',marginBottom:10 }}>
        {selectedTabIndex===0 && drawHistory}
        {selectedTabIndex===1 && dragons}
        {selectedTabIndex===2 && frequency}
        {selectedTabIndex===3 && routeMap}
        {selectedTabIndex===4 && statistics}
        
        {/* {selectedTabIndex===0 && historyDrawResult.length > 0 && historyDrawResult[1].lottery.toLowerCase()===game &&<Button style={{boxShadow:'0px 4px 6px rgba(11, 24, 50, 0.12)', marginBottom:10,borderRadius:10,marginTop:10,width:'calc( 100% - 20px)',borderBottomColor:'white', borderWidth:0,borderTopLeftRadius:0,borderTopRightRadius:0,paddingBottom:32,paddingTop:12}} onClick={()=>{
          setOpen(true)
        }}>{t('Show More')}</Button>} */}
      </div>
      {/* <DrawHistoryModal tab={selectedTab} open={open} afterClose={()=>setOpen(false)}/> */}
    </div>
  </>
}

export default LotteryDrawHistory;